import React from 'react';
import { Building2, Handshake, FileText, Banknote } from 'lucide-react';

export type DealType = 'conventional' | 'seller_financing' | 'wholesale' | 'cash';

interface DealTypeSelectorProps {
  value: DealType;
  onChange: (type: DealType) => void;
}

const dealTypes: { value: DealType; label: string; icon: React.ElementType; description: string }[] = [
  {
    value: 'conventional',
    label: 'Conventional',
    icon: Building2,
    description: 'Traditional bank financing with LTV/DSCR constraints'
  },
  {
    value: 'seller_financing',
    label: 'Seller Finance',
    icon: Handshake,
    description: 'Seller-carried note with negotiable terms'
  },
  {
    value: 'wholesale',
    label: 'Wholesale',
    icon: FileText,
    description: 'Quick assignment with MAO analysis'
  },
  {
    value: 'cash',
    label: 'Cash',
    icon: Banknote,
    description: 'All-cash purchase, no debt service'
  }
];

export const DealTypeSelector: React.FC<DealTypeSelectorProps> = ({ value, onChange }) => {
  return (
    <div className="flex gap-2">
      {dealTypes.map((type) => {
        const isActive = value === type.value;
        const Icon = type.icon;

        return (
          <button
            key={type.value}
            onClick={() => onChange(type.value)}
            className={`
              flex items-center gap-2 px-4 py-2.5 rounded-lg border-2 transition-all
              ${isActive
                ? 'bg-gold/10 border-gold text-gold'
                : 'bg-charcoal border-slate-dark text-stone-700 hover:border-zinc-500 hover:text-stone-700'
              }
            `}
            title={type.description}
          >
            <Icon size={18} />
            <span className="font-medium text-sm">{type.label}</span>
          </button>
        );
      })}
    </div>
  );
};
